
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.22 12.21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f8bf13","d":"M6.11 0C2.74 0 0 2.74 0 6.11s2.74 6.11 6.11 6.11 6.11-2.74 6.11-6.11S9.48 0 6.11 0zm0 10.42a4.31 4.31 0 110-8.62 4.31 4.31 0 010 8.62z"}}),_c('path',{attrs:{"fill":"#ce952e","d":"M3.43 6.39l1.6 1.6c.19.19.52.19.71 0l2.67-2.67.38-.38c.46-.46-.25-1.16-.71-.71L5.41 6.9l-.38.38h.71l-1.6-1.6c-.46-.46-1.16.25-.71.71z"}})])
          )
        }
      }
    